import script from "./newsCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./newsCategory.vue?vue&type=script&setup=true&lang=js"

import "./newsCategory.vue?vue&type=style&index=0&id=7e757f16&scoped=true&lang=css"

import exportComponent from "D:\\project\\哨兵官网\\Dtsc.Sentry.Offical.WebSite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e757f16"]])

export default __exports__